module.exports = __webpack_public_path__ + "d864b237e8e71d71a62fc07d1ed5cb4f.png";